import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import state from './state.js';
import getters from './getters.js';
import * as mutations from './mutations.js';
import * as actions from './actions.js';

import Authentication from './modules/authentication';
import GeneralSettings from './modules/general_settings';
import Roles from './modules/roles';
import Users from './modules/users';
import Reports from './modules/reports';
import Privileges from './modules/privileges';
import Regions from './modules/regions';
import Pricelists from './modules/pricelists';
import Projects from './modules/projects';
import Transport from './modules/transport';
import Vendors from './modules/vendors';
import Departments from './modules/departments';
import Branches from './modules/branches';
import InstallationCosts from './modules/installation_costs';
import Notifications from './modules/notifications';
import Processes from './modules/processes';
import Dashboard from './modules/dashboard';
import Stock from './modules/stock';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
	objAuthorize: state.objAuthorize,
	jwtAuth: state.jwtAuth,
	spineToken: state.spineToken,
  quotePagination: state.quotePagination
  })
});

export const store = new Vuex.Store({
	state: state,
	getters: getters,
	mutations,
	actions,
	plugins: [vuexLocalStorage.plugin],
	modules: {
		Authentication,
		GeneralSettings,
		Roles,
		Users,
		Reports,
		Privileges,
		Regions,
		Pricelists,
		Projects,
    Transport,
		Vendors,
    Departments,
    Branches,
		InstallationCosts,
    Notifications,
    Processes,
    Dashboard,
    Stock
	}
});
